import React, { Component, Fragment } from 'react';


import classnames from 'classnames';
import {blue,pink,green} from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, DialogActions, DialogTitle } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import ResourceView from '../view/ResourceView';
//import { PDFIcon, CSVIcon, JSONIcon, ZIPIcon} from '../icons';
import Download from '../../ajax/download';
import ClosableBar from '../dialogs/ClosableBar';

// import {bizpost} from '../../ajax';
// import {getNames} from '../../app/views/txnconfig';
import moment from 'moment';

const s:any = {
  root: {
    //width: '100%',
    flex: '1 1 auto',
    background: 'background.paper',
  },
  heading: {
    fontSize: 'typography.pxToRem(15)',
  },
  secondaryHeading: {
    fontSize: 'typography.pxToRem(15)',
    color: 'text.secondary',
  },
  secondaryHeading2: {
    fontSize: 'typography.pxToRem(15)',
    color: blue[600], //theme.palette.text.secondary,
  },
  topheading: {
    fontWeight:'bold',
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'center',
  },
  column: {
    flexBasis: '50%',
  },
  gridtitle: {
    fontSize: 'typography.pxToRem(15)',
    color: pink['500'],
    fontWeight:'bold',
  },
  gridroot: {
    width: '100%',
  },
  gridrow: {
    display: 'flex',
    width: 600,
    border: '1px solid #eeeeee',
    textAlign: 'left',
  },
  gridcolumnauto: {
    flexBasis: 'fill',
    textAlign: 'left',
    borderRight: '1px solid #eeeeee',
  },
  gridcolumn30: {
    flexBasis: 'auto',
    width: '200px',
    textAlign: 'left',
    borderRight: '1px solid #eeeeee',
  },
  gridcontent: {
    textAlign: 'left',
    paddingLeft: '20px',
  },
  dcolumn: {
    width: '100%',
    display: 'flex',
    flexBasis: '50%',
  },
  helper: {
    borderLeft: `2px solid gray`,
    p: '1 2',
  },
  link: {
    color: 'primary', //['500'],
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  iconsroot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  customicon: {
    margin: 'spacing(2)',
    color: pink["500"]
  },
  iconHover: {
    margin: 'spacing(2)',
    '&:hover': {
      color: green[200],
    },
  },
  
};

class SearchPreview extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loaded:false,
      views:[],
      count:0,
      data: []
    };
  }

  //TODO: Move this to src/app/services and keep a dummy failsafe version here.
  formatDate = (stamp:any) => {
    return moment(stamp,'YYYY-MM-DD HH:mm:ss.SSSSSS').format('DD-MMM-YYYY HH:mm');
  }
  //processTransaction = (record:any) => {
  // processRecord = (record:any) => {
  //   // const agent = {title:'Agent',data:[]};
  //   // const config = {title:'Configuration',data:[]};
  //   // const payload = {title:'Payload',data:[]};
  //   // const request = {title:'Request',data:[]};
  //   // const response = {title:'Response',data:[]};

  //   // const names = getNames('txn')(true);

  //   const {req,res} = record;
  //   const {aci,acn,acc,enm,eni,enc} = record; //activity
  //   const {evn,evc,vti,rfn,tri,dcd,stp,amt} = record; //event
  //   const {cnm,coc,mbn,idn,csn,eml} = record; //customer
  //   const {tdt,cuc,dtl} = record; //transaction
  //   const {} = record; //compliance

  //   // const request = [
  //   //   {t:'Request ID',v:rqi},
  //   //   {t:'Service',v:xtc},
  //   //   {t:'Channel',v:cln},
  //   //   {t:'Status',v:xsc},
  //   // ];

  //   // const event = [
  //   //   {t:'Event',v:evn},
  //   //   {t:'Reference',v:rfn},
  //   //   {t:'Track ID',v:tri},
  //   //   {t:'Created',v:dcd}
  //   // ];

  //   const customer = [
  //     {t:'Customer Name',v:csn},
  //     {t:'Email',v:eml},
  //     {t:'Mobile',v:mbn},
  //     {t:'ID Number',v:idn},
  //   ];

  //   const activity = [
  //     {t:'Activity Name',v:acn},
  //     {t:'Activity Code',v:acc},
  //     {t:'Entity',v:enm},
  //     {t:'Entity Code',v:enc},
  //   ];

  //   const event = [
  //     {t:'Reference ID',v:rfn},
  //     {t:'Track ID',v:tri},
  //     {t:'Created',v:this.formatDate(dcd)},
  //     {t:'Date Created', v:this.formatDate(stp)},
  //     // {t:'Currency',v:cuc},
  //     // {t:'Amount',v:amt},
  //     // {t:'Details',v:dtl},
  //   ];

  //   if(amt && vti ===2) event.push( {t:'Amount',v:`${cuc} ${(+amt).toFixed(2)}`} );

  //   // const compliance = [
  //   //   {t:'Status',v:nsc}
  //   // ]

  //   const rtn = [
  //    {title:'Activity',data:activity},
  //    {title:'Events',data:event},
  //    {title:'Customer',data:customer},
  //   //  {title:'Transaction',data:transaction},
  //   //  {title:'Compliance',data:compliance},
  //   ];

  //   return rtn;
  // }

  // showEmpty = (title:string,classes:any) => {
  //   return (
  //     <Fragment>
  //       <Accordion>
  //         <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  //           <Box sx={{...s.column}}>
  //             <Typography className={classnames(classes.heading,classes.topheading)}>
  //               {title}
  //             </Typography>
  //           </Box>
  //           <Box sx={{...s.column}}>
  //             <Typography className={classnames(classes.secondaryHeading,classes.topheading)}>
  //               {'N/A'}
  //             </Typography>
  //           </Box>
  //         </AccordionSummary>
  //         <AccordionDetails sx={{...s.details}}>
  //           <Box>
  //             N/A
  //           </Box>
  //           <Box></Box>
  //         </AccordionDetails>
  //       </Accordion>
  //     </Fragment>        
  //   )
  // }

  // showDetails = (rs:any,classes:any) => {
    
  //   return (
  //     <Fragment>
  //     {rs.map( (rsitem:any,rid:number) => (
  //       <Box key={`rs_${rid}`}>
  //         <Accordion>
  //           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  //             <Typography sx={{...s.heading}}>
  //               {rsitem.title}
  //             </Typography>
  //           </AccordionSummary>
  //           <AccordionDetails sx={{...s.details}}>
  //             <Box>
  //             {rsitem.data.map( (rec:any,idx:number) => (
  //               <Box key={`rs_${rid}_${idx}`}>
  //                 <Box sx={{...s.column}}>
  //                   <Typography sx={{...s.heading}}>
  //                     {rec.t}
  //                   </Typography>
  //                 </Box>
  //                 <Box sx={{...s.column}}>
  //                   <Typography sx={{...s.secondaryHeading}}>
  //                     {rec.v}
  //                   </Typography>
  //                 </Box>
  //               </Box>
  //             ))}
  //             </Box>
  //           </AccordionDetails>
  //         </Accordion>
  //       </Box>
  //     ))}
  //     </Fragment>
  //   );
  // }

  // showHistory = (record:any,classes:any) => {
  //   return (
  //     <Fragment>
  //       {(record.his && record.his.length>0)?
  //         <Accordion>
  //           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  //             <Typography className={classnames(classes.heading,classes.topheading)}>
  //             History
  //             </Typography>
  //           </AccordionSummary>
  //           <AccordionDetails sx={{...s.details}}>
  //             <Box>
  //               {record.his.map( (hisitem:any,i:number) => (
  //                 <Box key={`his_${i}`} sx={{...s.gridrow}}>
  //                 {/* <Box key={erritem.field} sx={{...s.gridrow}}> */}
  //                   <Box sx={{...s.gridcolumn30}}>
  //                     <Typography sx={{...s.heading}}>
  //                       <Box component='span'>{hisitem.stp}</Box>
  //                     </Typography>
  //                   </Box>
  //                   <Box sx={{...s.gridcolumnauto}}>
  //                     <Typography sx={{...s.secondaryHeading2}}>
  //                       <Box component='span'>{hisitem.rst}</Box>
  //                     </Typography>
  //                   </Box>
  //                   <Divider />
  //                 </Box>
  //               ))}
  //             </Box>
  //           </AccordionDetails>
  //         </Accordion>
  //       :""}
  //     </Fragment>
  //   );
  // }

  onClick = (name:any) => () => {
    //var btn = meter.target;
    var {data,record,user} = this.props;
    var d = new Download('','');
    d.downloadFile(name,data,record); //user
  } 

  onClose = (meter:any) => {
    const {onClose} = this.props;
    this.setState({loaded:false});
    if(typeof onClose == 'function') onClose();
  }

  render() {
    const {tabname,open,result,record,onClose,classes } = this.props;
    //const {data} = this.state;
    const name = tabname || 'Search';
    const title = `${name} Details`;
    const item = record;
    // const recordset = this.processRecord(record);
    // const details = this.showDetails(recordset,classes);
    // const history = this.showHistory(record,classes);
    return (
      <Fragment>
        <Dialog open={open}  sx={{...s.dialog}} classes={{paper: classes.dialogcontent}}>
          <DialogTitle sx={{...s.titlebar}}><ClosableBar onClose={this.onClose}>{title}</ClosableBar></DialogTitle>
          <DialogContent sx={{...s.dialogcontent}}>
            <Box sx={{...s.root}}>
              {/* {record.his.map( (hisitem:any,i:number) => ( */}
                  {/* <Box key={`his_${i}`} sx={{...s.gridrow}}> */}
                  <Box key={'row01'} sx={{...s.gridrow}}>
                    <Box sx={{...s.gridcolumn30}}>
                      <Typography sx={{...s.heading}}>
                        <Box component='span'>Module</Box>
                      </Typography>
                    </Box>
                    <Box sx={{...s.gridcolumnauto}}>
                      <Typography sx={{...s.secondaryHeading2}}>
                        <Box component='span'>{record.tbl}</Box>
                      </Typography>
                    </Box>
                    <Divider />
                  </Box>
                  <Box key={'row02'} sx={{...s.gridrow}}>
                    <Box sx={{...s.gridcolumn30}}>
                      <Typography sx={{...s.heading}}>
                        <Box component='span'>Record ID</Box>
                      </Typography>
                    </Box>
                    <Box sx={{...s.gridcolumnauto}}>
                      <Typography sx={{...s.secondaryHeading2}}>
                        <Box component='span'>{record.rid}</Box>
                      </Typography>
                    </Box>
                    <Divider />
                  </Box>
                  <Box key={'row03'} sx={{...s.gridrow}}>
                    <Box sx={{...s.gridcolumn30}}>
                      <Typography sx={{...s.heading}}>
                        <Box component='span'>Last Updated</Box>
                      </Typography>
                    </Box>
                    <Box sx={{...s.gridcolumnauto}}>
                      <Typography sx={{...s.secondaryHeading2}}>
                        <Box component='span'>{record.stp}</Box>
                      </Typography>
                    </Box>
                    <Divider />
                  </Box>
                  <Box key={`row04`} sx={{...s.gridrow}}>
                    <Box sx={{...s.gridcolumn30}}>
                      <Typography sx={{...s.heading}}>
                        <Box component='span'>Details</Box>
                      </Typography>
                    </Box>
                    <Box sx={{...s.gridcolumnauto}}>
                      <Typography sx={{...s.secondaryHeading2}}>
                        <Box component='span'>{record.tsh}</Box>
                      </Typography>
                    </Box>
                    <Divider />
                  </Box>

                {/* ))} */}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="secondary" onClick={this.onClose}><CloseIcon/>Close </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export default SearchPreview;
